import { create } from "zustand";
import { axiosHelper, tokenHelper } from "./helpers";
// import { filterNonFalseValues } from "./helpers/Utlis";

export const useStaffStore = create((set, get) => ({
  staffs: [],
  users: [],

  teamManagementData: null,
  isLoading: false,
  isError: false,
  error: undefined,
  filters: null,
  pagination: null,
  // Methods
  getStaffs: async () => {
    // set({ filters: filterNonFalseValues(filters) });
    // 
    const body = {
      // search: filterNonFalseValues(filters)?.search,
      // sortDirection: "desc",
      // sortField: "createdAt",
      // dateFrom: "",
      // dateTo: "",
      // page: filters?.page || 1,
      // limit: filters?.limit || 10,
    };

    try {
      set({ isLoading: true });
      let response = await axiosHelper.post(
        "/system/manage-staff/get/staffs",
        body
      );

      if (!response.result) {
        return;
      }
      // 

      set({ staffs: response.data, isLoading: false });
    } catch (error) {
      console.error("Error fetching staffs:", error);
    } finally {
      set({ isLoading: false });
    }
  },

  getAllUsers: async ({ page, perPage }) => {
    set({ isLoading: true, users: [] }); // Clear users immediately


    try {
      // Get the access token
      const accessToken = await tokenHelper.getToken();

      // Post the site creation request
      const response = await axiosHelper.get(
        `/v2/user?page=${page}&perPage=${perPage}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      // Only update if this is still the current request
      set({ users: response?.users, pagination: response?.pagination });
    } catch (e) {

      return false;
    } finally {
      set({ isLoading: false });
    }
  },
  searchUsers: async (search) => {
    set({ isLoading: true, users: [] }); // Clear users immediately

    try {


      // Get the access token
      const accessToken = await tokenHelper.getToken();

      // Post the site creation request
      const response = await axiosHelper.get(`/v2/user/search/${search}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      // Handle the response structure - check if it has users array or is the array itself
      if (Array.isArray(response)) {
        set({ users: response, pagination: { totalItems: response.length } });
      } else {
        set({ users: response?.users || response, pagination: response?.pagination || { totalItems: (response?.users || response)?.length || 0 } });
      }
    } catch (e) {

      return false;
    } finally {
      set({ isLoading: false });
    }
  },
  updateUser: async (userId, body) => {
    set({ isLoading: true });

    try {
      // Get the access token
      const accessToken = await tokenHelper.getToken();


      // Post the site creation request
      const response = await axiosHelper.patch(`/user/update/${userId}`, body, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });


      // Refresh with current pagination state
      const state = get();
      if (state.pagination) {
        get().getAllUsers({
          page: state.pagination.currentPage || 1,
          perPage: state.pagination.perPage || 10,
        });
      } else {
        get().getAllUsers({ page: 1, perPage: 10 });
      }

      // set({ users: response });
    } catch (e) {

      return false;
    } finally {
      set({ isLoading: false });
    }
  },
  addUser: async (body) => {
    set({ isLoading: true });

    try {
      // Get the access token
      const accessToken = await tokenHelper.getToken();


      // Post the site creation request
      const response = await axiosHelper.post(`/user/create`, body, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });


      // Refresh with current pagination state
      const state = get();
      if (state.pagination) {
        get().getAllUsers({
          page: state.pagination.currentPage || 1,
          perPage: state.pagination.perPage || 10,
        });
      } else {
        get().getAllUsers({ page: 1, perPage: 10 });
      }

      // set({ users: response });
    } catch (e) {

      return false;
    } finally {
      set({ isLoading: false });
    }
  },
  deleteUser: async (userId) => {
    set({ isLoading: true });

    try {
      // Get the access token
      const accessToken = await tokenHelper.getToken();

      // Post the site creation request
      const response = await axiosHelper.delete(`/user/delete/${userId}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      // Refresh with current pagination state
      const state = get();
      if (state.pagination) {
        get().getAllUsers({
          page: state.pagination.currentPage || 1,
          perPage: state.pagination.perPage || 10,
        });
      } else {
        get().getAllUsers({ page: 1, perPage: 10 });
      }

      return true;
    } catch (e) {

      return false;
    } finally {
      set({ isLoading: false });
    }
  },
  updateUserPermissions: async (userId, permissions) => {
    set({ isLoading: true });

    try {
      // Get the access token
      const accessToken = await tokenHelper.getToken();

      // Update user permissions
      const response = await axiosHelper.patch(
        `/user/${userId}/permissions`,
        permissions,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );



      // Refresh with current pagination state
      const state = get();
      if (state.pagination) {
        get().getAllUsers({
          page: state.pagination.currentPage || 1,
          perPage: state.pagination.perPage || 10,
        });
      } else {
        get().getAllUsers({ page: 1, perPage: 10 });
      }

      return true;
    } catch (e) {
      console.error("Error updating permissions:", e);
      return false;
    } finally {
      set({ isLoading: false });
    }
  },

  // Invitation-related methods
  verifyInvitationToken: async (token) => {
    set({ isLoading: true, isError: false, error: undefined });

    try {

      const response = await axiosHelper.get(`/user/verify-invitation/${token}`);

      set({ isLoading: false });


      // The response is the data directly, not wrapped in response.data
      return response;
    } catch (error) {
      console.error("Store: Error verifying invitation token:", error);
      set({
        isLoading: false,
        isError: true,
        error: error.response?.data?.message || "Failed to verify invitation token"
      });
      throw error;
    }
  },

  acceptInvitation: async (token) => {
    set({ isLoading: true, isError: false, error: undefined });

    try {
      const accessToken = await tokenHelper.getToken();
      const response = await axiosHelper.post(
        "/user/accept-invitation",
        { token },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      set({ isLoading: false });
      return response;
    } catch (error) {
      console.error("Error accepting invitation:", error);
      set({
        isLoading: false,
        isError: true,
        error: error.response?.data?.message || "Failed to accept invitation"
      });
      throw error;
    }
  },

  acceptInvitationToken: async (token) => {
    set({ isLoading: true, isError: false, error: undefined });

    try {
      const response = await axiosHelper.post("/user/accept-invitation-token", { token });
      set({ isLoading: false });
      return response;
    } catch (error) {
      console.error("Error accepting invitation token:", error);
      set({
        isLoading: false,
        isError: true,
        error: error.response?.data?.message || "Failed to accept invitation token"
      });
      throw error;
    }
  },

  declineInvitationToken: async (token) => {
    set({ isLoading: true, isError: false, error: undefined });

    try {
      const response = await axiosHelper.post("/user/decline-invitation-token", { token });
      set({ isLoading: false });
      return response;
    } catch (error) {
      console.error("Error declining invitation token:", error);
      set({
        isLoading: false,
        isError: true,
        error: error.response?.data?.message || "Failed to decline invitation token"
      });
      throw error;
    }
  },
  verifyInvitationTokenAccepted: async (token) => {
    set({ isLoading: true, isError: false, error: undefined });
    try {
      const response = await axiosHelper.get(`/user/verify-invitation-token-accepted/${token}`);
      set({ isLoading: false });
      return response;
    } catch (error) {
      console.error("Error verifying invitation token accepted:", error);
      set({
        isLoading: false,
        isError: true,
        error: error.response?.data?.message || "Failed to verify invitation token accepted"
      });
      throw error;
    }
  },
  registerUser: async (userData) => {
    set({ isLoading: true, isError: false, error: undefined });

    try {
      const response = await axiosHelper.post("/v2/user/auth/register", {
        name: userData.name,
        email: userData.email,
        password: userData.password,
        phone: userData.phone,
        role: "USER",
        userLanguage: "EN",
        max_daily_orders: 20,
        phoneOS: "android",
      });
      set({ isLoading: false });
      return response;
    } catch (error) {
      console.error("Error registering user:", error);
      set({
        isLoading: false,
        isError: true,
        error: error.response?.data?.message || "Failed to register user"
      });
      throw error;
    }
  },

  registerWithInvitation: async (userData, token) => {
    set({ isLoading: true, isError: false, error: undefined });

    try {
      const response = await axiosHelper.post("/user/register-with-invitation", {
        name: userData.name,
        email: userData.email,
        password: userData.password,
        phone: userData.phone,
        token: token,
      });
      set({ isLoading: false });
      return response;
    } catch (error) {
      console.error("Error registering with invitation:", error);
      set({
        isLoading: false,
        isError: true,
        error: error.response?.data?.message || "Failed to register with invitation"
      });
      throw error;
    }
  },


  // Invitation management methods
  invitations: [],
  invitationsLoading: false,
  invitationsError: null,

  getAllInvitations: async () => {

    set({ invitationsLoading: true, invitationsError: null });

    try {
      const accessToken = await tokenHelper.getToken();


      const response = await axiosHelper.get("/user/invitations", {
        headers: { Authorization: `Bearer ${accessToken}` },
      });



      set({
        invitations: response || [],
        invitationsLoading: false
      });
      return response;
    } catch (error) {
      console.error("Store: Error fetching invitations:", error);
      set({
        invitationsLoading: false,
        invitationsError: error.response?.data?.message || "Failed to fetch invitations"
      });
      throw error;
    }
  },

  cancelInvitation: async (inviteId) => {
    set({ invitationsLoading: true, invitationsError: null });

    try {
      const accessToken = await tokenHelper.getToken();
      const response = await axiosHelper.patch(
        `/user/invitations/${inviteId}/cancel`,
        {},
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      // Refresh invitations list
      get().getAllInvitations();

      set({ invitationsLoading: false });
      return response;
    } catch (error) {
      console.error("Error cancelling invitation:", error);
      set({
        invitationsLoading: false,
        invitationsError: error.response?.data?.message || "Failed to cancel invitation"
      });
      throw error;
    }
  },

  resendInvitation: async (inviteId) => {
    set({ invitationsLoading: true, invitationsError: null });

    try {
      const accessToken = await tokenHelper.getToken();
      const response = await axiosHelper.post(
        `/user/invitations/${inviteId}/resend`,
        {},
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      // Refresh invitations list
      get().getAllInvitations();

      set({ invitationsLoading: false });
      return response;
    } catch (error) {
      console.error("Error resending invitation:", error);
      set({
        invitationsLoading: false,
        invitationsError: error.response?.data?.message || "Failed to resend invitation"
      });
      throw error;
    }
  },

  createUserLinks: async (inviteId) => {
    set({ isLoading: true, isError: false, error: undefined });

    try {
      const accessToken = await tokenHelper.getToken();
      const response = await axiosHelper.post(
        "/user/create-user-links",
        { invite_id: inviteId },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      set({ isLoading: false });
      return response;
    } catch (error) {
      console.error("Error creating user links:", error);
      set({
        isLoading: false,
        isError: true,
        error: error.response?.data?.message || "Failed to create user links"
      });
      throw error;
    }
  },

  // Get team management data (merged links + invitations)
  getTeamManagementData: async (filters = null, pagination = { page: 1, perPage: 10 }) => {
    try {
      set({ isLoading: true, isError: false, error: null });

      const accessToken = await tokenHelper.getToken();

      const response = await axiosHelper.post(`/user/team-management`,
        {
          page: pagination.page,
          perPage: pagination.perPage,
          filters: filters || {},
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      set({
        teamManagementData: response.data,
        pagination: response.pagination,
        isLoading: false,
        isError: false,
        error: null
      });

      return response;
    } catch (error) {
      console.error("Error fetching team management data:", error);
      set({
        isLoading: false,
        isError: true,
        error: error.response?.data?.message || "Failed to fetch team management data"
      });
      throw error;
    }
  },
}));
